@if (form) {
  <form [formGroup]="form" (ngSubmit)="search()">
    <div class="row">
      <rask-input class="col-2" aid="fritextSokproduktinstruktion" label="Fritext" formControlName="sokText"></rask-input>
      <rask-input class="col-2" aid="sortimentProduktionstruktionsok" label="Sortiment" formControlName="sortiment"></rask-input>
      <rask-input class="col-2" aid="handelssortimentProduktionstruktionsok" label="Handelssortiment" formControlName="handelssortiment"></rask-input>
      <rask-tree-selector class="col-2" label="Geografi" [autoSort]="true" [sortExpression]="regionerSortExpression" [items]="regionerItems" formControlName="regioner">
      </rask-tree-selector>
    </div>
    <div class="row">
      <rask-input class="col-2" aid="mottagningsplatsProduktionstruktionsok" label="Mottagningsplats" formControlName="mottagningsplats"></rask-input>
      <rask-multi-selector
        formControlName="tradslag"
        class="col-2"
        label="Trädslag"
        [items]="tradslagsList"
        aid="tradslagProduktionstruktionsok">
      </rask-multi-selector>
      <div class="col">
        <rask-radiobutton-group aid="aktivRadio" label="Aktiv" [buttons]="activetypes" formControlName="aktiv"></rask-radiobutton-group>
        <div class="d-inline-block produktinstruktion-search-button-style">
          <rask-submit-button color="secondary" aid="sandningsloggSok">Sök</rask-submit-button>
          <rask-button aid="buttonRensa" color="secondary" negative (click)="reset()">Rensa</rask-button>
        </div>
      </div>
    </div>
  </form>
}

